import { ContactBlock } from "../components/sections";

export default function Contact() {
  return <ContactBlock />;
}
